import React from 'react';
import {Col, Row} from "react-bootstrap";
import {TextField} from "@material-ui/core";

const DigitalAccounts = () => {
    return (
        <div className="personal_affairs_container">
            <div className="info_header">
                <h3>Digital Accounts</h3>
            </div>
            {Array(3).fill(1).map((ele,index)=> (
                <div className="content mt-3 mb-5" key={index}>
                    {["Name:", "Site:", "User:", "Password:"].map((title) => (
                        <Row className="mx-0" key={title}>
                            <Col md="3 pl-0">
                                {title}
                            </Col>
                            <Col md="9">
                                <TextField
                                    variant="filled"
                                    fullWidth={true}
                                    size="small"
                                />
                            </Col>
                        </Row>
                    ))}
                    <Row className="my-2 mx-0">
                        <Col md="12 pl-0">
                            Notes:
                        </Col>
                        <Col md="12 pl-0">
                            <TextField
                                variant="filled"
                                fullWidth={true}
                                size="small"
                                multiline={true}
                                rows={4}
                            />
                        </Col>
                    </Row>
                </div>
            ))}
        </div>
    );
};

export default DigitalAccounts;